import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9004/api'

export const getInfomaDocumentPage = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/infoma/page`
  return doGet(url)
}

export const saveInfomaDocument = (projectVersionId, request) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/infoma/upload`
  return doPost(url, request)
}

export const downloadFileByPath = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const deleteInfomaDocumentById = (id) => {
  const url = `${API_ROOT}/contract/infoma/delete/${id}`
  return doDelete(url)
}

export const sendFileToInfoma = (id, request) => {
  const url = `${API_ROOT}/contract/${id}/infoma/send-file-to-infoma`
  return doPost(url, request)
}

export const getInfomaSystemDocument = (projectVersionId) => {
  const url = `${API_ROOT}/contract/${projectVersionId}/infoma-doc`
  return doGet(url)
}
